import React from "react";
import InputText from "../InputText";

const InputNumberSchema = ({ item: schema, ...props }) => {
  return <InputText type={schema.type} min={schema.minimum} max={schema.maximum} {...props} />;
};

export default InputNumberSchema;
